import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["media", "srcSet"]
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("picture", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pictureSources, (source, i) => {
      return (_openBlock(), _createElementBlock("source", {
        key: i,
        media: source.media,
        srcSet: source.src
      }, null, 8, _hoisted_1))
    }), 128)),
    _createElementVNode("img", {
      class: "emh-stage-campaign-item__image-img",
      src: _ctx.pictureFallbackImgSrc,
      loading: "lazy",
      draggable: false,
      alt: _ctx.pictureDescription
    }, null, 8, _hoisted_2)
  ]))
}